<template>
  <div class="def-go-to-top" :class="{ 'def-go-to-top_active': isActive }" @click="handlerClick">
    <svg>
      <use xlink:href="#svg-arrow-top"></use>
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { scrollPageTo } from '@/utils/helpers';

const isActive = ref(false);

const handlerScroll = () => {
  const position = window.scrollY;

  if (position > 50) {
    isActive.value = true;
  } else {
    isActive.value = false;
  }
};

const handlerClick = () => {
  scrollPageTo(0, 600);
};

onMounted(() => {
  window.addEventListener('scroll', handlerScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener('scroll', handlerScroll);
});
</script>

<style lang="scss" scoped>
.def-go-to-top {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 51px;
  height: 51px;
  position: fixed;
  right: calc(18px + var(--scrollbar-compensation, 0px));
  bottom: 60px;
  background-color: #fff;
  opacity: 0;
  pointer-events: none;
  transition: 0.3s linear opacity, 0.3s linear background-color;
  z-index: 2;

  border-radius: 50%;
  box-shadow: 0 4px 15px rgb(0 0 0 / 8%);
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
    stroke: var(--background-black);
    transition: 0.3s linear stroke;
  }

  &_active {
    opacity: 1;
    pointer-events: auto;
  }

  &:hover {
    background-color: var(--background-black);
    svg {
      stroke: #fff;
    }
  }
}
</style>
